import React, {useContext, useEffect, useState} from 'react';
import { Redirect, useHistory } from 'react-router';
import LoginAPI from '../../api/login/login';
import './login.css';
import {Link} from 'react-router-dom';
import CheckCookie from '../../api/user/user';
import Loader from '../../components/loader/loader';
import AlertDialog from '../../components/alert dialog/dialog';
import LoginImage from '../../assets/Sign Up Login Image.jpg';
import { AuthorizationContext } from '../../context/authorizationContext';

const Login = ()=>{
    const [loggedin, setLoggedin] = useState(false);
    const [user, setUser] = useState({
        email: "",
        password: ""
    });
    const [visible_loader, setVisibleLoader] = useState(false);
    const { setPath } = useContext(AuthorizationContext);

    setPath(window.location.pathname);

    useEffect(()=>{
        Validation();
    }, [user])

    const Validation = ()=>{
        const {email, password} = user;
        if(!email || !password){
            return false;
        }
        else{
            return true;
        }
    }

    const Login = (e)=>{
        e.preventDefault();
        const {email, password} = user;

        if(!email || !password){
            console.log("Not valid");
        }
        else{
            const test_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(test_email.test(email) === true){
                setVisibleLoader(true);
                LoginAPI({email, password}, (response)=>{
                    console.log("Printing response of login api call in login.jsx", response);
                    if(response.data.status === true){
                        console.log("Status is true");
                        setVisibleLoader(false);
                        window.location.replace("https://onboard-10.web.app//");
                    }
                    else{
                        console.log(false);
                        setVisibleLoader(false);
                        alert(response.data.data);
                    }
                }, (error)=>{
                    setVisibleLoader(false);
                    console.log(error);
                    alert("Something went wrong, Please try again later.!");
                })
            }
        }
    }

    return (
        loggedin !== true ? 
        <>
            {visible_loader === true && <Loader />}
            <div className="login_section">
                <div className='left_section'>
                    <div className="box">
                        <h1>Login</h1>
                        <form method="POST">
                            <div className="input">
                                <input type="email" name="email" id="email" value={user.email} onChange={(event)=>{
                                    setUser({...user, email: event.target.value})
                                }} placeholder="Email Address..." required={true} />
                            </div>
                            <div className="input">
                                <input type="password" name="password" id="password" value={user.password} onChange={(event)=>{
                                    setUser({...user, password: event.target.value})
                                }} required={true} placeholder="Password..." />
                            </div>
                            <div className="submit">
                                <button disabled={!Validation()} style={Validation() === true ? {} : {background: "grey"}} onClick={Login}>Login</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className='right_section'>
                    <img src={LoginImage} />
                </div>
            </div>
        </> : <Redirect to="/" />
    )
};

export default Login;